import { useState, useEffect } from "react";

// Matches Tailwind's `lg` breakpoint (mobile = below 1024px)
export default function useIsMobile(bp = 1024) {
  const q = `(max-width:${bp - 1}px)`;
  const [m, setM] = useState(() => typeof window !== "undefined" && window.matchMedia(q).matches);
  useEffect(() => {
    const mm = window.matchMedia(q);
    const h = (e) => setM(e.matches);
    mm.addEventListener("change", h);
    setM(mm.matches);
    return () => mm.removeEventListener("change", h);
  }, [q]);
  return m;
}
